// extracted by mini-css-extract-plugin
module.exports = {"no-scroll":"no-scroll--2ecef","noScroll":"no-scroll--2ecef"};